import React from 'react';
import * as C from "../componentsM/index"

const CulminatingEvents = () => {
    return (
        <>


            <C.Hero title={"CULMINATING EVENTS"}
                image={"/hero/history.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>Primary Years Programme Exhibition</h1>

                    <p>In the final year of the PYP, students participate in a culminating project, the PYP Exhibition. This requires that each student demonstrates engagement with the five essential elements of the programme: knowledge, concepts, skills, attitudes and action. It is a transdisciplinary enquiry conducted in the spirit of personal and shared responsibility, as well as a summative assessment activity that is a celebration as students move from the PYP into the middle years of schooling.</p>

                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>Middle Years Programme Personal Project</h1>

                    <p>The Personal Project encourages students to practice and strengthen their approaches to learning (ATL) skills, to consolidate prior and subject-specific learning, and to develop an area of personal interest. The personal project provides an excellent opportunity for students to produce a truly personal and often creative product/outcome and to demonstrate a consolidation of their learning in the MYP. The project offers many opportunities for differentiation of learning and expression according to students’ individual needs. The personal nature of the project is important; the project should revolve around a challenge that motivates and interests the individual student. The Personal Project enables students to engage in practical explorations through a cycle of enquiry, action and reflection.</p>

                    <p>The personal project has three components</p>

                    <ul className=" my-2">
                        {[
                            "1. Focus on topic leading towards a product/outcome – this is evident in the presentation/ report",
                            "2. Process journal-a selection of extracts in the appendices of the report",
                            "3. The report-the content of the report is assessed using all four criteria"
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>


                    <p>What are the AIMS of the Personal Project?</p>

                    <p>The aims of the Personal Project will enable students to:</p>


                    <ul className="list-disc list-inside my-2">
                        {[
                            "Participate in a sustained, self-directed enquiry within a global context",
                            "Generate creative new insights and develop deeper understandings through in-depth investigation",
                            "Demonstrate the skills, attitudes and knowledge required to complete a project over an extended period of time",
                            "Communicate effectively in a variety of situations",
                            "Demonstrate responsible action through, or as a result of, learning",
                            "Appreciate the process of learning and take pride in their accomplishments."
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>


                    <p>All students are required to achieve at least a grade 3 in the Personal Project in order to achieve MYP certification.</p>

                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>Personal Project Exhibition</h1>


                    <p>Personal Project is a key component of the Middle Years Programme and an essential requirement to attain MYP certification. To assist parents in understanding the aims, objectives and requirements of the project, an annual Personal Project exhibition is held for the students of MYPs 4 and 5 of the upcoming academic session. The aim of the Personal Project exhibition is to stimulate ideas in the minds of students who will be managing their own projects in years to come.</p>


                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>Diploma Programme Extended Essay</h1>


                    <p>The Extended Essay is an in-depth study of a focused topic chosen from the list of approved Diploma Programme subjects—normally one of the student’s six chosen subjects for the IB diploma. It is intended to promote high-level research and writing skills, intellectual discovery and creativity. It provides students with an opportunity to engage in personal research in a topic of their own choice, under the guidance of a supervisor (a teacher in the school). This leads to a major piece of formally presented, structured writing, in which ideas and findings are communicated in a reasoned and coherent manner, appropriate to the subject chosen. Completion of the written essay is followed by a short, concluding interview, or viva voce, with the supervisor.</p>


                    <p>The Extended Essay is assessed against common criteria, interpreted in ways appropriate to each subject. The Extended Essay is:</p>



                    <ul className="list-disc list-inside my-2">
                        {[
                            "Compulsory for all Diploma Programme students",
                            "Externally assessed and, in combination with the grade for theory of knowledge, contributes up to three points to the total score for the IB diploma",
                            "A piece of independent research/investigation on a topic chosen by the student in cooperation with a supervisor in the school",
                            "Chosen from the list of approved Diploma Programme subjects, published in the Handbook of Procedures for the Diploma Programme",
                            "Presented as a formal piece of scholarship containing no more than 4,000 words",
                            "The result of approximately 40 hours of work by the student",
                            "Concluded with a short interview, or viva voce, with the supervising teacher (recommended)."
                        ].map((item, index) => (
                            <li key={index} className="text-sm">{item}</li>
                        ))}
                    </ul>


                    <p>In the Diploma Programme, the Extended Essay is the prime example of a piece of work where the student has the opportunity to show knowledge, understanding and enthusiasm about a topic of his or her choice. In those countries where it is the norm for interviews to be required prior to acceptance for employment or for a place at university, the extended essay has often proved to be a valuable stimulus for discussion.</p>


                </div>



            </section>

        </>
    )
}

export default CulminatingEvents